import { render, staticRenderFns } from "./card-cart.vue?vue&type=template&id=46230cd9&scoped=true"
import script from "./card-cart.vue?vue&type=script&lang=js"
export * from "./card-cart.vue?vue&type=script&lang=js"
import style0 from "./card-cart.vue?vue&type=style&index=0&id=46230cd9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46230cd9",
  null
  
)

export default component.exports